import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="font-bold text-xl mb-4 text-blue-400">SuddyFlow</h3>
            <p className="text-gray-400 text-sm mb-4">
              The complete CRM built for exterior service professionals. 
              Manage your business with confidence.
            </p>
            <div className="mt-4">
              <span className="bg-red-600 text-white px-3 py-1 rounded-full text-xs font-semibold">
                🇺🇸 Veteran-Owned
              </span>
            </div>
            <div className="mt-4 text-xs text-gray-500">
              <p>Serving professionals in:</p>
              <p>Pressure Washing • Landscaping</p>
              <p>Window Cleaning • Tree Service</p>
              <p>Christmas Lights • More</p>
            </div>
          </div>
          
          {/* Product Links */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Product</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/features" className="text-gray-400 hover:text-white transition-colors">
                  Features
                </Link>
              </li>
              <li>
                <Link to="/pricing" className="text-gray-400 hover:text-white transition-colors">
                  Pricing
                </Link>
              </li>
              <li>
                <Link to="/register" className="text-gray-400 hover:text-white transition-colors">
                  Start Free Trial
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Company Links */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Company</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/about" className="text-gray-400 hover:text-white transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-400 hover:text-white transition-colors">
                  Contact
                </Link>
              </li>
              <li>
                <Link to="/trust" className="text-gray-400 hover:text-white transition-colors">
                  🔒 Trust & Security
                </Link>
              </li>
            </ul>
          </div>
          
          {/* Legal Links */}
          <div>
            <h4 className="font-semibold mb-4 text-white">Legal</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link to="/privacy" className="text-gray-400 hover:text-white transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-400 hover:text-white transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/sms-policy" className="text-gray-400 hover:text-white transition-colors">
                  SMS Policy
                </Link>
              </li>
            </ul>
            <div className="mt-6">
              <h4 className="font-semibold mb-2 text-white text-sm">Contact</h4>
              <p className="text-gray-400 text-sm">
                Mooresville, NC<br />
                Lake Norman Area
              </p>
            </div>
          </div>
        </div>
        
        {/* Bottom Bar */}
        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-sm text-gray-400">
            © {currentYear} Suddy Buckets LLC. All rights reserved. 
            <span className="ml-2">Built with 💪 by veterans, for professionals.</span>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;